import { Controller, useFormContext } from 'react-hook-form';
import { Divider, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { User_CreateUpdateUserInput } from 'queries';

import FormPhoneField from 'common/form-phone-field';
import FormTextField from 'common/form-text-field';

const useStyles = makeStyles(() => ({
  formContainer: {
    display: 'flex',
  },
  buttonContainer: {
    float: 'right',
    marginBottom: '10vh',
    width: '45vw',
  },
  divider: {
    backgroundColor: '#F5DE76',
    width: 'auto',
    position: 'relative',
    marginLeft: '20px',
    marginRight: '20px',
  },
  title: {
    color: '#096094',
    marginBottom: '1vh',
  },
  saveButton: {
    backgroundColor: '#F5DE76',
    marginRight: '2.5vw',
    float: 'right',
  },
  cancelButton: {
    color: '#ffffff',
    backgroundColor: '#8DA8B2',
    float: 'right',
  },
  input: {
    padding: '1vh 2vh',
  },
}));

const ConciergeForm = () => {
  const classes = useStyles();

  const {
    control,
    formState: { errors },
  } = useFormContext<User_CreateUpdateUserInput>();

  return (
    <>
      <Grid container>
        <Grid spacing={3} xs={12} item md={6}>
          <div className={classes.input}>
            <Controller
              name="firstName"
              control={control}
              render={({ field: { ref, ...field } }) => (
                <FormTextField
                  {...field}
                  ref={ref}
                  errorMessage={errors.firstName?.message}
                  label="First Name"
                />
              )}
            />
          </div>
        </Grid>
        <Grid spacing={3} xs={12} item md={6}>
          <div className={classes.input}>
            <Controller
              name="lastName"
              control={control}
              render={({ field: { ref, ...field } }) => (
                <FormTextField
                  {...field}
                  ref={ref}
                  errorMessage={errors.lastName?.message}
                  label="Last Name"
                />
              )}
            />
          </div>
        </Grid>
        <Grid spacing={3} xs={12} item md={6}>
          <div className={classes.input}>
            <Controller
              name="email"
              control={control}
              render={({ field: { ref, ...field } }) => (
                <FormTextField
                  {...field}
                  ref={ref}
                  errorMessage={errors.email?.message}
                  label="Email"
                />
              )}
            />
          </div>
        </Grid>
        <Grid spacing={3} xs={12} item md={6}>
          <Controller
            name="phone"
            control={control}
            render={({ field: { name, onBlur, onChange, value } }) => (
              <FormPhoneField
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                errorMessage={errors.phone?.message}
                label="Phone Number"
              />
            )}
          />
        </Grid>
        <Grid>
          <Grid spacing={3} xs={12} item md={12}>
            <div className={classes.input}>
              <Controller
                name="calendar"
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <FormTextField
                    {...field}
                    ref={ref}
                    errorMessage={errors.calendar?.message}
                    label="Calendar Link"
                  />
                )}
              />
            </div>
          </Grid>
          <Grid spacing={3} xs={12} item md={12}>
            <div className={classes.input}>
              <Controller
                name="message"
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <FormTextField
                    {...field}
                    ref={ref}
                    errorMessage={errors.message?.message}
                    label="Preview Message"
                  />
                )}
              />
            </div>
          </Grid>
        </Grid>

        <Grid xs={12}>
          <Divider className={classes.divider} />
        </Grid>
      </Grid>
    </>
  );
};

export default ConciergeForm;
